var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttonBox"},_vm._l((_vm.buttonList),function(item,index){return _c('div',{key:index,staticClass:"button-item m-l",class:{'button-item-select':index==_vm.buttonIndex,'button-item-hui':_vm.BGColor},on:{"click":function($event){return _vm.selectButtonSelect(index)}}},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }